module.exports = __webpack_public_path__ + "static/event-driven-queue-7b64a29d966999c7e472796fb5e1d0eb.png";